import { Component, inject, OnInit, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { KeycloakSessionService } from '../../services/keycloak-session.service';
import { IMPERSONATION_SESSION_STORAGE_KEY } from '../../utils/constants.impersonation';
import { TranslatePipe } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';
import { ProductPlacementComponent } from '../product-placement/product-placement.component';

@Component({
  selector: 'app-waiting-list',
  templateUrl: './waiting-list.component.html',
  styleUrls: ['./waiting-list.component.scss'],
  imports: [TranslatePipe, ProductPlacementComponent],
})
export class WaitingListComponent implements OnInit {
  sessionId = signal<string | undefined>(undefined);

  readonly isImpersonating: boolean;

  private authService = inject(AuthService);
  private sessionService = inject(KeycloakSessionService);
  private keycloak = inject(Keycloak);

  constructor() {
    this.isImpersonating =
      sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) !== null;
  }

  ngOnInit(): void {
    const sessionId = this.keycloak.tokenParsed?.['sid'] as string;
    this.sessionId.set(sessionId);
  }

  async logout() {
    await this.authService.logout(window.location.origin);
  }

  async endImpersonation() {
    const exit = () => {
      // Close the current tab
      sessionStorage.removeItem(IMPERSONATION_SESSION_STORAGE_KEY);
      window.close();

      // Reload the current page if closing the tab fails (Scripts may close only the windows that were opened by them.)
      window.location.reload();
    };

    const sessionId = this.sessionId();
    if (sessionId) {
      firstValueFrom(this.sessionService.terminate(sessionId)).finally(exit);
    } else {
      exit();
    }
  }
}
